import { applyMark } from '../utils/apply-mark';
export var code = function code(maybeNode) {
  return applyMark({
    type: 'code'
  }, maybeNode);
};